
  import { defineComponent, inject } from "vue";

  import { v4 as uuidv4 } from "uuid";
  import Popper from "vue3-popper";

  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";
  import { set } from "lodash";

  export default defineComponent({
    name: "FormRepeaterV2",

    components: { Popper },

    extends: BaseProcessComponentV2,

    provide() {
      return {
        [this.formRepeaterContext]: this.items,
      };
    },

    setup(props: any) {
      const root: string = props.path.split(".")[0];

      return {
        [root]: inject(root),
      };
    },

    data() {
      return {
        internalValue: null as any,
        items: {} as any,
        formRepeaterContext: uuidv4(),
      };
    },

    watch: {
      items: {
        deep: true,
        handler() {
          set(this, this.path, Object.values(this.items));
        },
      },
    },

    async mounted() {
      this.internalValue = { [uuidv4()]: {} };

      if (Array.isArray(this.value) && this.value.length > 0) {
        for (const item of this.value) {
          this.items[uuidv4()] = item;
        }
      } else {
        this.items[uuidv4()] = {};
      }
    },

    methods: {
      async addWrapper() {
        if (await this.v$.$validate()) {
          this.items[uuidv4()] = {};
        }
      },

      async allowAddWrappers() {
        return true;
      },

      allowRemoveWrapper() {
        return Object.keys(this.items).length > 1;
      },

      removeWrapper(id: string) {
        const { [id]: _, ...newObj } = this.items;

        this.items = newObj;
      },
    },
  });
